export const blockIconsCommonactionsNewReleasesNew = (
	<span className='material-symbols-outlined'>new_releases</span>
);
